import React from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { SEO_FAQ } from "../seo/faq";

const EQUIPMENT_BLOCKS = [
  {
    id: "bakery-machines",
    title: "Bakery Machines in Kanpur",
    body: (
      <>
        <strong>Rahul Engineering Works Kanpur</strong> designs and builds
        industrial <strong>bakery machines</strong> for bread, rusk and biscuit
        plants across India. From single ovens to fully automatic lines, our
        factory at Udyog Kunj, Panki supplies reliable equipment with installation
        support and spare parts. Search for bakery machines Kanpur — REW has
        served the industry since 1992 with 1000+ installations.
      </>
    ),
  },
  {
    id: "bakery-ovens",
    title: "Industrial Bakery Ovens",
    body: (
      <>
        Our <strong>bakery oven</strong> range includes rotary rack ovens, swing
        tray ovens, chain tunnel ovens and wire mesh tunnel ovens for high-volume
        baking. Whether you need a commercial oven for bread loaves or continuous
        rusk baking, Rahul Engineering Works manufactures ovens built for even heat,
        durability and daily production in Indian bakery conditions.
      </>
    ),
    link: { to: "/products", label: "View all bakery ovens" },
  },
  {
    id: "bakery-mixers",
    title: "Dough Mixers for Bakeries",
    body: (
      <>
        REW <strong>mixers</strong> cover slow speed, spiral, high speed and
        planetary models for every dough and batter application. A quality bakery
        mixer improves batch consistency, reduces labour and supports scale-up from
        artisan units to industrial plants. Buy mixer machines in Kanpur directly
        from the manufacturer — Rahul Engineering Works.
      </>
    ),
    link: { to: "/products", label: "Explore bakery mixers" },
  },
  {
    id: "bakery-slicers",
    title: "Bread & Rusk Slicers",
    body: (
      <>
        Precision <strong>slicers</strong> for sandwich bread, rusk and retail
        packs — available in slow speed and high speed configurations. Uniform slice
        thickness, hygienic design and easy maintenance make our slicers essential
        for modern bakery packaging lines supplied from Kanpur to clients nationwide.
      </>
    ),
    link: { to: "/products", label: "See bread & rusk slicers" },
  },
  {
    id: "rahul-engineering-kanpur",
    title: "Rahul Engineering Works, Kanpur",
    body: (
      <>
        Looking for <strong>Rahul Engineering Works Kanpur</strong> or{" "}
        <strong>Rahul Engineering Work Kanpur</strong>? You have found the official
        website. We are a Make in India bakery equipment manufacturer in{" "}
        <strong>Kanpur, Uttar Pradesh</strong>, exporting and installing machinery
        pan-India. Call +91 8077558106 or visit our Panki plant for a consultation
        on ovens, mixers, slicers and complete bakery lines.
      </>
    ),
    link: { to: "/#contact", label: "Contact REW Kanpur" },
  },
];

const SeoContentSection = () => {
  return (
    <section
      id="bakery-equipment-kanpur"
      className="py-16 lg:py-20 bg-[#111111] border-t border-[#c9923f]/10"
      aria-labelledby="seo-content-heading"
    >
      <div className="container mx-auto px-6 lg:px-12 max-w-5xl">
        <h2
          id="seo-content-heading"
          className="text-3xl lg:text-4xl font-bold text-white mb-4"
        >
          Bakery Machines, Ovens, Mixers &amp; Slicers — Kanpur
        </h2>
        <p className="text-gray-300 text-lg leading-relaxed mb-10">
          <Link
            to="/products"
            className="text-[#c9923f] hover:text-[#d4a574] font-medium"
          >
            Rahul Engineering Works
          </Link>{" "}
          is your Kanpur-based partner for industrial bakery equipment. Below is
          what we manufacture and supply when customers search for bakery machines,
          oven, mixer, slicer or Rahul Engineering Works Kanpur online.
        </p>

        <div className="space-y-10 mb-14">
          {EQUIPMENT_BLOCKS.map((block) => (
            <article key={block.id} id={block.id} className="scroll-mt-28">
              <h3 className="text-xl lg:text-2xl font-semibold text-[#c9923f] mb-3">
                {block.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">{block.body}</p>
              {block.link && (
                <Link
                  to={block.link.to}
                  className="inline-block mt-3 text-sm uppercase tracking-wider text-[#d4a574] hover:text-[#c9923f] transition-colors"
                >
                  {block.link.label} →
                </Link>
              )}
            </article>
          ))}
        </div>

        <div id="faq">
          <h3 className="text-2xl font-bold text-white mb-6">
            Frequently Asked Questions
          </h3>
          <Accordion type="single" collapsible className="w-full">
            {SEO_FAQ.map((item, index) => (
              <AccordionItem
                key={item.question}
                value={`faq-${index}`}
                className="border-[#c9923f]/20"
              >
                <AccordionTrigger className="text-left text-white hover:text-[#c9923f]">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-300 leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default SeoContentSection;
